var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85,2.5a.76.76,0,0,1,.75.75V7H9.34a1.05,1.05,0,0,1,.49.13l2.56,1.46a1,1,0,0,1,.45,1.19l-1,3a1,1,0,0,1-1,.71H6.62a1,1,0,0,1-.82-.43L3.2,9.33a.51.51,0,0,1,0-.63,1.54,1.54,0,0,1,1.17-.54,1.86,1.86,0,0,1,.34,0l1.35.3V3.25a.76.76,0,0,1,.75-.75m0-1.5A2.23,2.23,0,0,0,6,1.18a2,2,0,0,0-.71.48A2.25,2.25,0,0,0,4.6,3.25V6.67H4.41a3,3,0,0,0-2.3,1A2,2,0,0,0,2,10.19l2.6,3.74A2.5,2.5,0,0,0,6.62,15h4.24a2.34,2.34,0,0,0,.79-.13,2.58,2.58,0,0,0,.7-.36,2.48,2.48,0,0,0,.55-.57,2.22,2.22,0,0,0,.34-.69l1-3a2.49,2.49,0,0,0-1.13-3L10.58,5.83A2.48,2.48,0,0,0,9.34,5.5H9.1V3.25A2.25,2.25,0,0,0,6.85,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaint);
export default __webpack_public_path__ + "static/media/icon_paint.f8a5b21a6b0b8658cb0652145c2fd185.svg";
export { ForwardRef as ReactComponent };